$(document).ready(function(){

    let swiper = new Swiper('.mainBox .right', {
        pagination: {
            el: '.focusPage',
          },
    })
    
})